// How long the planning board waits after the last edit before it saves the
// working draft on its own.
export const AUTOSAVE_DELAY_MS = 1500
